import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {
  AppTableComponent, ModalWindowComponent, SearchModel, SearchResultModel, SupplierAuctionOfferListModel,
  Auth, MessagesComponent, SupplierAuctionOfferService
} from 'src/common';
import {TranslationManager} from 'src/common/translation';
import {Router} from '@angular/router';


@Component({
  selector: 'app-supplier-auction-offer-list-ssy1250list',
  templateUrl: './supplier-auction-offer-list-ssy1250list.component.html'
})
export class SupplierAuctionOfferListSsy1250listComponent implements AfterViewInit, OnInit {

  // custom-constructor-start
  constructor
  (
    private router: Router,
    private supplierAuctionOfferListViewService: SupplierAuctionOfferService)
    {}

  // custom-constructor-end

  @ViewChild(AppTableComponent) appTable: AppTableComponent;
  @ViewChild("modalWindow") modalWindow: ModalWindowComponent;
  translationManager = TranslationManager;
  items: SupplierAuctionOfferListModel[];
  idForDelete: number;
  showDeleteModal: boolean = false;
  auth = Auth;
  customHeaderText = '';

  displayParticipateModal = false;
  selectedRequestRoundSupplierId: number;

  ngOnInit(): void {
    //this.initForm();
  }


  ngAfterViewInit(): void {
    this.appTable.onSearch = this.doSearch.bind(this);
    this.appTable.search();
  }

  doSearch(search: SearchModel) {
    this.supplierAuctionOfferListViewService.
    search(search).then((result: SearchResultModel<SupplierAuctionOfferListModel>) => {
      // this.items = result.items;

      // debugger;

      this.items = result.items.map(item => {
        // MOCK --- START
        // item.auctionDeadline = new Date();
        // item.auctionDeadline.setSeconds(item.auctionDeadline.getSeconds() + 30);
        // MOCK --- END
        // item.auctionEnded = !item.auctionDeadline || (new Date() >= item.auctionDeadline);
        if(item.isFinished){
          item.auctionEnded = item.isFinished;
        }else{
          item.auctionEnded = !item.auctionDeadline || (new Date() >= new Date(item.auctionDeadline));
        }


        item.auctionStarted = item.auctionStartDate && (new Date() >= new Date(item.auctionStartDate));
        return item;
      });

      this.appTable.setTotalCount(result.totalCount);
    });
  }

  create() {
    this.routerNavigateToCreate();
  }


  openDetails(id: number) {
    this.router.navigate(['/supplierAuctionOfferLists/details/' + id]);
  }

  delete() {
    this.showDeleteModal = false;
    this.supplierAuctionOfferListViewService.delete(this.idForDelete).then(() => {
      this.supplierAuctionOfferListViewService.getAll().then((items: SupplierAuctionOfferListModel[]) => {
        this.items = items;
      });
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Подаци су успешно обрисани')]);
    });
  }

  showDeleteModalFor(id: number) {
    this.idForDelete = id;
    this.showDeleteModal = true;
  }

  public routerNavigateToCreate() {
    this.router.navigate(['auctions/create']);
  }

  showParticipateModalFor(id: number, participate) {
    this.selectedRequestRoundSupplierId = id;
    this.displayParticipateModal = true;
  }

  partcipate() {
    let status = 'AttendanceConfirmed';

    this.supplierAuctionOfferListViewService.acceptAuction({
      'id': this.selectedRequestRoundSupplierId,
      'status': status
    })
      .then(() => {
      MessagesComponent.instance.showSuccess([this.translationManager.getTranslation('Успешно сачуван ентитет')]);
      this.displayParticipateModal = false;
      this.appTable.onSearch = this.doSearch.bind(this);
      this.appTable.search();
    }).catch((reason: any) => {
      this.displayParticipateModal = false;
      if (reason !== null) {
        if (reason.status === 400) {
          if (reason.error !== null) {
            if (reason.error.message) {
              const mescustom = reason.error.message;
              MessagesComponent.instance.showError([mescustom]);
            }
          }
        } else {
          MessagesComponent.instance.showError(reason.error.messages);
        }
      }
    });
  }

  auctionEnded(auctionId: number) {
    const item = this.items.find(i => i.auctionId === auctionId);
    item && (item.auctionEnded = true);
  }

}

